import styled from 'styled-components';

export const WrapperCommercialCart = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas:
        "checkoutCart"
        "bodyCart"
    ;
    gap: 24px;
    align-items: start;

    @media ${({ theme }) => theme.screenSizes.tablet} {
        grid-template-columns: auto minmax(320px, 450px);
        grid-template-areas: "bodyCart checkoutCart";
        gap: 10px;
    }
`;

// Wrappers para asignar áreas a los hijos
export const BodyCartArea = styled.div`
    grid-area: bodyCart;
    min-width: 0;
`;

export const CheckoutCartArea = styled.div`
    grid-area: checkoutCart;
    min-width: 0;

    /* Sticky solo aplica cuando hay 2 columnas (>= tablet) */
    @media ${({ theme }) => theme.screenSizes.tablet} {
        align-self: start;
        position: sticky;
        top: 0px;
    }
`;